// Climax (Venus): the last star of every constellation scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const climax: AlignmentDef = {
  id: 'climax',
  planet: 'venus',
  name: 'Climax',
  text: () => `The last star of every constellation scores +${N.climaxPercent}%.`,
  starPercent: (star, c) => (star.index === c.nodes.length - 1 ? N.climaxPercent : 0),
};
